import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import {
  getQuizByIdCall,
  postQuizStartCall,
  getQuizByIdResultCall,
  postQuizByIdNextCall,
} from './api';

type sagaIteratorFunction = () => SagaIterator;

export const allSagas: sagaIteratorFunction[] = [
  getQuizByIdCall.saga,
  postQuizStartCall.saga,
  getQuizByIdResultCall.saga,
  postQuizByIdNextCall.saga,
];

export function* quizRootSaga(): SagaIterator {
  yield all(allSagas.map((s: sagaIteratorFunction) => fork(s)));
}
